import axios from '../../shared/services/axios.service';
import { ImportType } from '../interfaces/import-type';
import { from, Observable } from 'rxjs';
import { ImportLines, ImportLinesRequest } from '../interfaces/import-lines';
import { NewImportType } from '../interfaces/dto/new-import-type';
import { UploadFile } from '../interfaces/upload-file';

export const getImportTypes = (): Observable<ImportType[]> =>
    from(
        axios.get<ImportType[]>('/imports')
            .then(res => res.data),
    );

export const createImportType = (importType: NewImportType): Observable<ImportType> =>
    from(
        axios.post('/imports', { ...importType })
            .then(res => res.data),
    );

export const uploadGeoJsonFile = (uploadFile: UploadFile): Observable<ImportType> =>
    from(
        axios.post(`/imports/${uploadFile.importTypeId}`, uploadFile.formData)
            .then(res => {
                return res.data;
            }),
    );

export const uploadImportEnedis = (importTypeId: number, scheduledAt?: string, clearBeforeImport?: boolean, resumeFromUrl?: string): Observable<ImportType> =>
    from(
        axios.post(`/imports/Enedis/${importTypeId}`, null, {
            params: {
                scheduledAt, // undefined = non envoyé => lancement immédiat
                clearBeforeImport: clearBeforeImport || false,
                resumeFromUrl, // undefined = non envoyé => import depuis le début
            },
        })
            .then(res => {
                return res.data;
            }),
    );

// Recalcule les totaux côté serveur et renvoie la liste complète à jour
export const refreshTotals = (): Observable<ImportType[]> =>
    from(
        axios.put<ImportType[]>('/imports/refresh-totals')
            .then(res => res.data),
    );

export const clearImportType = (id: number): Observable<ImportType> =>
    from(
        axios.put(`/imports/${id}/clear`)
            .then(res => res.data),
    );

// Lignes d'un import à afficher sur la carte. Sans bounds (params undefined => non envoyés),
// l'api renvoie un premier échantillon et le centre où placer la carte.
export const getImportLines = (request: ImportLinesRequest): Observable<ImportLines> =>
    from(
        axios.get<ImportLines>(`/imports/${request.importTypeId}/lines`, { params: request.bounds })
            .then(res => res.data),
    );